export function mapItineraryToTeaser(itinerary) {

    return {
        contentType: 'itinerary',
        publicLink: itinerary.detailPageUrl,
        title: itinerary.title,
        teaser: itinerary.teaser,
        additionalData: {
            uid: itinerary.uid,
            inRiverImage: itinerary.teaserImageUrl,
            price: parseInt(itinerary.price, 10),
            serviceFeeText: itinerary.serviceFeeText,
            label: itinerary.label,
            isInstantBookable: itinerary.isInstantBookable,
            travelArea: itinerary.travelarea,
            soldOut: itinerary.soldOut,
            priceInformation: itinerary.priceInformation,
            priceValidityPeriod: itinerary.priceValidityPeriod
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/teaserMapper.js